import axios from "axios";
import { apiURI } from "../ENVs";

// The user manual is stored as a PDF in the `qualityreports` container, under a virtual
// `manuals/` folder (Azure folders are just `/`-prefixed blob names). It's served through the
// authenticated backend proxy (GET /form/pdf). Upload the manual to this exact blob path.
const USER_MANUAL_BLOB = "manuals/quality-report-user-manual.pdf";
// Name the user sees when the file is saved/opened. A blob: URL has no filename, so we must
// set it explicitly via the download attribute — otherwise the browser shows the object-URL id.
const USER_MANUAL_FILENAME = "quality-report-user-manual.pdf";

export async function openUserManual() {
  try {
    // Fetch with the JWT (default axios header); the backend streams the PDF via Managed
    // Identity — the browser never talks to storage directly.
    const { data } = await axios.get(`${apiURI}/form/pdf`, {
      params: { path: USER_MANUAL_BLOB },
      responseType: "blob",
    });

    // Trigger a download with the proper filename. (Browsers don't allow auto-opening a
    // downloaded file in a tab; the saved PDF opens with the correct name when clicked.)
    const objectUrl = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = USER_MANUAL_FILENAME;
    document.body.appendChild(a);
    a.click();
    a.remove();
    // Revoke after a tick so the browser has started reading the blob for the download
    // (revoking synchronously can cancel the download in some browsers).
    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
  } catch (error) {
    console.log({ error });
  }
}
